var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChevroninline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#CCDDC7",
  stroke: "#6E9E8F",
  d: "M12.451 9.26639C13.183 9.89761 13.183 10.9774 12.451 11.6086L3.86676 19.0111C2.77289 19.9544 1 19.2302 1 17.84L1 3.03496C1 1.64483 2.7729 0.920576 3.86676 1.86385L12.451 9.26639Z"
})));
export default SvgChevroninline;